/**
 * AVTR Collection Mobile — Interaction Scripts
 * ─────────────────────────────────────────────
 * - Filter drawer open/close with body scroll lock
 * - Sticky filter bar shadow on scroll
 * - Lazy-load image fade-in via IntersectionObserver
 * - Grid entrance animation control
 */

(function () {
  'use strict';

  /* ═══════════════════════════════════════════
     1. FILTER DRAWER
     ═══════════════════════════════════════════ */

  const drawer = document.getElementById('avtr-filter-drawer');
  const trigger = document.getElementById('avtr-filter-trigger');
  const closeBtn = document.getElementById('avtr-filter-close');
  const overlay = drawer ? drawer.querySelector('.avtr-filter-drawer__overlay') : null;

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('avtr-drawer-open');

    // Trap focus inside drawer
    requestAnimationFrame(function () {
      if (closeBtn) closeBtn.focus();
    });
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('avtr-drawer-open');

    // Return focus to trigger
    if (trigger) trigger.focus();
  }

  if (trigger) {
    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      openDrawer();
    });
  }

  if (closeBtn) {
    closeBtn.addEventListener('click', function (e) {
      e.preventDefault();
      closeDrawer();
    });
  }

  if (overlay) {
    overlay.addEventListener('click', function () {
      closeDrawer();
    });
  }

  // Close on Escape key
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) {
      closeDrawer();
    }
  });


  /* ═══════════════════════════════════════════
     2. STICKY FILTER BAR — border on scroll
     ═══════════════════════════════════════════ */

  var filterBar = document.querySelector('.avtr-mobile-filter-bar');

  if (filterBar && 'IntersectionObserver' in window) {
    // Create a sentinel element right above the filter bar
    var sentinel = document.createElement('div');
    sentinel.style.height = '1px';
    sentinel.style.width = '100%';
    sentinel.style.position = 'absolute';
    sentinel.style.top = '0';
    sentinel.style.left = '0';
    sentinel.style.pointerEvents = 'none';
    sentinel.setAttribute('aria-hidden', 'true');

    // Insert sentinel before filter bar
    if (filterBar.parentNode) {
      filterBar.parentNode.style.position = 'relative';
      filterBar.parentNode.insertBefore(sentinel, filterBar);
    }

    var stickyObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) {
            filterBar.classList.add('is-stuck');
          } else {
            filterBar.classList.remove('is-stuck');
          }
        });
      },
      {
        threshold: [0],
        rootMargin: '-' + (parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 60) + 'px 0px 0px 0px'
      }
    );

    stickyObserver.observe(sentinel);
  }


  /* ═══════════════════════════════════════════
     3. LAZY-LOAD IMAGE FADE-IN
     ═══════════════════════════════════════════ */

  function initLazyFadeIn() {
    var lazyImages = document.querySelectorAll('.avtr-collection-grid .avtr-card__image-wrap img[loading="lazy"]');

    if (!lazyImages.length) return;

    if ('IntersectionObserver' in window) {
      var imageObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              var img = entry.target;

              // If already loaded (cached), add class immediately
              if (img.complete && img.naturalHeight > 0) {
                img.classList.add('is-loaded');
              } else {
                img.addEventListener('load', function () {
                  img.classList.add('is-loaded');
                }, { once: true });

                // Handle error case
                img.addEventListener('error', function () {
                  img.classList.add('is-loaded');
                }, { once: true });
              }

              imageObserver.unobserve(img);
            }
          });
        },
        {
          rootMargin: '100px 0px',
          threshold: 0.01
        }
      );

      lazyImages.forEach(function (img) {
        // If already loaded (from cache), skip observer
        if (img.complete && img.naturalHeight > 0) {
          img.classList.add('is-loaded');
        } else {
          imageObserver.observe(img);
        }
      });
    } else {
      // Fallback: just show all images
      lazyImages.forEach(function (img) {
        img.classList.add('is-loaded');
      });
    }
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLazyFadeIn);
  } else {
    initLazyFadeIn();
  }


  /* ═══════════════════════════════════════════
     4. GRID ENTRANCE ANIMATION CONTROL
     ═══════════════════════════════════════════ */

  // After initial entrance animation completes, mark grid as "loaded"
  // so subsequent DOM updates (filtering, etc.) don't re-animate
  var grid = document.querySelector('.avtr-collection-grid');
  if (grid) {
    setTimeout(function () {
      grid.classList.add('avtr-loaded');
    }, 800); // enough time for staggered entrance
  }


  /* ═══════════════════════════════════════════
     5. RE-INIT ON SHOPIFY SECTION RENDER
     ═══════════════════════════════════════════ */

  // When Shopify re-renders sections (filtering, AJAX pagination),
  // re-initialize the lazy-load observer
  document.addEventListener('shopify:section:load', function () {
    initLazyFadeIn();
  });

})();
